// From https://stackoverflow.com/questions/42118296/dynamically-import-images-from-a-directory-using-webpack
import { Utils } from '../Utils';

const context = require.context('./icons', true, /\.\/(.+?)#?\.svg$/) // filter is nameRegex

const nameRegex = /\.\/@?(.+)\.svg$/
const starredNameRegex = /\.\/@(.+)\.svg$/

export type MoveIcon = {
	name: string,
	path: string,
	isStarred: boolean
}

export const MoveIcons: MoveIcon[] = context.keys()
	.map(key => ({
		name: key.match(nameRegex)!![1],
		path: context(key).default,
		isStarred: starredNameRegex.test(key)
	}))

export const MoveIconMap = Utils.associateWith(MoveIcons, i => i.name)

export const StarredMoveIcons = MoveIcons.filter(({ isStarred }) => isStarred)
export const NotStarredMoveIcons = MoveIcons.filter(({ isStarred }) => !isStarred)